import { ApolloCache, ApolloClient } from '@apollo/client'
import { cacheAccountDebitCardList } from 'features/Accounts'
import { omit } from 'lodash'

import { GetAccountDebitCardsVerbose_getDebitCardAccountV2_cards as AccountDebitCard } from 'types/gql-types/GetAccountDebitCardsVerbose'
import { GetDebitCardsList_getDebitCardsV2_cards as DebitCard } from 'types/gql-types/GetDebitCardsList'

import { cacheDebitCardList } from '../cacheDebitCardList/cacheDebitCardList'

interface CacheNewDebitCardProps {
  cache: ApolloCache<any>
  newCard: DebitCard
  client?: ApolloClient<any>
}

export const cacheNewDebitCard = ({
  cache,
  newCard,
  client,
}: CacheNewDebitCardProps) => {
  const updateCardsList = (oldCards: (DebitCard | null)[]) => {
    const isCardAlreadyCached = oldCards.some(
      (existingCard) => existingCard?.id === newCard.id
    )

    if (isCardAlreadyCached) {
      return oldCards.map((existingCard) => {
        if (existingCard?.id === newCard.id) {
          return newCard
        }

        return existingCard
      })
    }
    return [newCard, ...oldCards]
  }

  cacheDebitCardList({ cache, mapToNewList: updateCardsList, client })
  const cacheCardToAccount = cacheAccountDebitCardList(
    newCard.debitCardAccount.id
  )

  const updateAccountCardsList = (
    oldAccountCards: (AccountDebitCard | null)[]
  ) => {
    const newAccountDebitCard: AccountDebitCard = omit(
      newCard,
      'debitCardAccount'
    )
    const isCardAlreadyCached = oldAccountCards.some(
      (existingCard) => existingCard?.id === newCard.id
    )

    if (isCardAlreadyCached) {
      return oldAccountCards.map((existingCard) => {
        if (existingCard?.id === newAccountDebitCard.id) {
          return newAccountDebitCard
        }

        return existingCard
      })
    }
    return [newAccountDebitCard, ...oldAccountCards]
  }

  cacheCardToAccount({
    cache,
    mapToNewList: updateAccountCardsList,
  })
}
